import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Popover } from 'antd';
import SelectTax from '@Components/Admin/Common/SelectTax';
import H3FormInput from '@Uilib/h3FormInput';
import H3Image from '@Uilib/h3Image';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import closeIcon from '@Images/icons/icon-close-blue.png';
import './style.scss';
import { EditOutlined } from '@ant-design/icons';

const FreightTaxInput = ({
  freightTaxId, setFreightTaxData, openFreightTax, setOpenFreightTax, sacCode, setSacCode, freightTax,
}) => (
  <div className="freight-tax__wrapper">
    <Popover
      content={(
        <div>
          <div style={{ marginBottom: '10px' }} className="freight-tax__value">
            <SelectTax
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              onChange={(value) => {
                setFreightTaxData(value);
              }}
              selectedGST={freightTaxId}
              noTax
            />
          </div>
          <div className="freight-tax__value">
            <div className="orgInputContainer">
              <H3FormInput
                name=""
                type="number"
                containerClassName="orgInputContainer"
                labelClassName="orgFormLabel"
                inputClassName="orgFormInput"
                placeholder=""
                onChange={(event) => setSacCode(event.target.value)}
                value={sacCode}
                label="SAC Code"
                maxlength="6"
              />
            </div>
          </div>

          <div className="freight-tax__footer">
            <H3Button
              text="Apply"
              buttonType={defaultButtonTypes.BLUE_ROUNDED}
              customClass="freight-tax__footer-submit"
              onClick={() => setOpenFreightTax(false)}
            />
          </div>
        </div>
      )}
      title={(
        <div className="freight-tax__title-wrapper" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>Tax on Freight</div>
          <div>
            <H3Image
              src={closeIcon}
              className="freight-tax__close-icon"
              onClick={() => setOpenFreightTax(false)}
            />
          </div>
        </div>
      )}
      placement="bottomRight"
      trigger="click"
      open={openFreightTax}
      onOpenChange={() => setOpenFreightTax(!openFreightTax)}
    >
      <div onClick={() => {
        if (openFreightTax) {
          setOpenFreightTax(false);
        }
      }}
      >
        <EditOutlined />
        {freightTaxId ? ' Edit Tax' : ' Add Tax'}
      </div>
    </Popover>
  </div>
);

const mapStateToProps = ({
}) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

FreightTaxInput.propTypes = {
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FreightTaxInput));
